import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Button, Glyphicon } from '@bingads-webui-react/primitive';
import { getBackMenuItemStyles } from '../../../styles/back-menu-item-styles';

const BackMenuItem = ({
  classes, backText, onBackClicked,
}) => (
  <Button
    className={classNames(classes.backButton, 'back-button')}
    onClick={onBackClicked}
    btnStyle="command"
    aria-label={backText}
  >
    <Glyphicon
      className={classNames(classes.backIcon)}
      glyph="ba-Back"
    />
    <div className={classes.backTextDiv}>
      <span className={classNames(classes.backTextContainer, 'back-button-text')}>{backText}</span>
    </div>
  </Button>
);

BackMenuItem.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getBackMenuItemStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  backText: PropTypes.string.isRequired,
  onBackClicked: PropTypes.func.isRequired,
};

export default withDefaultStyles(BackMenuItem, getBackMenuItemStyles);
